module.exports = __webpack_public_path__ + "img/42.377a584a.jpg";